import React, { FC } from 'react';
import cx from 'classnames';
import styles from './CardWrapper.module.scss';

interface CardWrapperProps {
	children: JSX.Element | JSX.Element[];
	backgroundColor?: string;
	className?: string;
}

const CardWrapper: FC<CardWrapperProps> = ({ children, backgroundColor = '', className = '' }): JSX.Element => {
	return (
		<section
			data-testid='card-wrapper-id'
			className={cx(styles.CardWrapper, className)}
			style={{ backgroundColor: backgroundColor }}
		>
			{children}
		</section>
	);
};

export { CardWrapper };
